import Component from '@bythepixel/component-loader';
import { eventThrottle } from '@Core/utility';
import GlideSlider from '../../base';

const desktopBreakpoint = 768;

// Refer to https://glidejs.com/docs/options/
const glideOptions = {
  type: 'slider',
  startAt: 0,
  perView: 1,
  breakpoints: {
    767: {
      type: 'carousel',
    },
  },
};

const selectors = {
  slideSelector: '[data-logo-slider-slide]',
  slideIndicatorSelector: '[data-logo-slider-indicator]',
  slideIndicatorActiveClass: 'glide__bullet--active',
};

export default class SectionBasicLogoSlider extends Component {
  static selector = '[data-comp-basic-logo-slider]';
  static loaderPriority = 'in-view';

  constructor(containerEl) {
    super(containerEl);
    this.slider = new GlideSlider(containerEl, glideOptions, selectors);
    this.sliderGlideInstance = this.slider.getGlideSlider();

    // Run these events after mounting the slide and after transitioning between slides
    this.sliderGlideInstance.on(['mount.after', 'run.after'], () => {
      const slideWidth = this.slider.getSliderWidth();

      this.slider.adjustSlideWidth(slideWidth);
    });

    // Run this event before transitioning the slide
    this.sliderGlideInstance.on('run', () => {
      this.slider.handleSlideIndicatorActiveState();
    });

    // Run this event only after mounting the slide
    this.sliderGlideInstance.on('mount.after', () => this.slider.disableSliderInDesktopView(desktopBreakpoint));

    this.sliderGlideInstance.mount();

    window.addEventListener(
      'resize',
      eventThrottle(() => {
        this.slider.disableSliderInDesktopView(desktopBreakpoint);
        this.updateBasicLogoSliderBetweenBreakpoints(desktopBreakpoint);
      }, 100),
    );
  }

  /*
   * Updates basic logo slider between breakpoints
   * @return {void}
   */
  updateBasicLogoSliderBetweenBreakpoints(breakpoint) {
    if (window.matchMedia(`(min-width: ${breakpoint}px)`).matches) {
      this.sliderGlideInstance.update({
        startAt: 0,
        type: 'slider',
      });
    } else {
      this.sliderGlideInstance.update({
        type: 'carousel',
      });
    }
  }
}
